import * as React from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Link from '@mui/material/Link';
import AppBar from '../components/AppBar';
import Toolbar from '../components/Toolbar';
import HeaderContent from '../../../views/layout/MainLayout/Header/HeaderContent';
import ThemeToggle from '../../../views/layout/MainLayout/Header/HeaderContent/ThemeToggle';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { useTheme } from '@emotion/react';
import trainSvg from '../../../assets/images/stations.svg';

const RightLink = styled(Link)(({ theme }) => ({
    fontSize: 16,
    color: theme.palette.common.white,
    ml: 3,
    [theme.breakpoints.up('xs')]: {
        fontSize: '0.8rem',
        paddingRight: '12px'
    },
    [theme.breakpoints.up('md')]: {
        fontSize: '1rem',
        paddingRight: '18px'
    }
}));

function AppAppBar() {
    const { authStatus } = useAuthenticator((context) => [context.authStatus]);
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const appBarGradient = isDarkMode
        ? `linear-gradient(90deg, ${theme.palette.primary.lighter} 0%, ${theme.palette.primary[200]} 50%, ${theme.palette.primary.light} 100%)`
        : 'linear-gradient(90deg, #1b5e20 0%, #2e7d32 50%, #388e3c 100%)';

    return (
        <div>
            <AppBar position="fixed" sx={{ background: appBarGradient }}>
                <Toolbar>
                    <Box sx={{ display: { xs: 'none', md: 'flex' }, flex: 1 }} />
                    <Link
                        variant="h6"
                        underline="none"
                        color={theme.palette.common.white}
                        href="/"
                        sx={{
                            fontSize: { xs: '2rem', md: '3rem' },
                            display: 'flex',
                            alignItems: 'center',
                            fontWeight: 'bold',
                            textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
                        }}
                    >
                        <Box
                            component="img"
                            src={trainSvg}
                            alt="train"
                            sx={{
                                mr: 1,
                                height: { xs: '2rem', md: '3rem' },
                                width: 'auto'
                            }}
                        />
                        {'Stations'}
                    </Link>
                    {authStatus !== 'authenticated' ? (
                        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                            <Box sx={{ mr: 1 }}>
                                <ThemeToggle />
                            </Box>
                            <RightLink color="inherit" variant="h6" underline="none" href="/login/">
                                {'Sign In'}
                            </RightLink>
                            <RightLink color="inherit" variant="h6" underline="none" href="/register/">
                                {'Sign Up'}
                            </RightLink>
                            <RightLink color="inherit" variant="h6" underline="none" href="/#contact">
                                {'Contact'}
                            </RightLink>
                        </Box>
                    ) : (
                        <HeaderContent />
                    )}
                </Toolbar>
            </AppBar>
            <Toolbar />
        </div>
    );
}

export default AppAppBar;
